import { ProductType } from "@obg/core.config";

import { WALLET_ACTION_TYPE } from "./wallet.action";
import { BonusContext } from "./wallet.model";

export const DEFAULT_TRANSACTION_BONUS_CONTEXTS = [
	{
		bonusContext: [],
		productType: ProductType.Common,
	},
	{
		bonusContext: [BonusContext.Casino, BonusContext.MobileCasino],
		productType: ProductType.Casino,
	},
	{
		bonusContext: [BonusContext.LiveCasino, BonusContext.MobileLiveCasino],
		productType: ProductType.LiveCasino,
	},
	{
		bonusContext: [
			BonusContext.Sportsbook,
			BonusContext.MobileSportsbook,
			BonusContext.SportsbookLive,
			BonusContext.MobileSportsbookLive,
			BonusContext.SportsbookEttKryssTva,
		],
		productType: ProductType.Sportsbook,
	},
	{
		bonusContext: [BonusContext.VirtualSports, BonusContext.MobileVirtualSports],
		productType: ProductType.VirtualSports,
	},
	{
		bonusContext: [BonusContext.MgPoker, BonusContext.Poker, BonusContext.MobileMgPoker, BonusContext.MobilePoker],
		productType: ProductType.Poker,
	},
	{
		bonusContext: [BonusContext.NlcPoker, BonusContext.MobileNlcPoker],
		productType: ProductType.TurkishPoker,
	},
];

const CONTEXT_PREFIX = "[Wallet]";
export const WALLET_MESSAGE_CONTEXT = {
	getBalance: `${CONTEXT_PREFIX} Get Balance`,
	getBetWinSummary: WALLET_ACTION_TYPE.getBetWinSummary,
	getTransaction: WALLET_ACTION_TYPE.getTransaction,
	getTransactions: WALLET_ACTION_TYPE.getTransactions,
	getWithdrawalRestriction: WALLET_ACTION_TYPE.getWithdrawalRestrictions,
};

export const WALLET_MESSAGE_CODES = {
	transactions: {
		failure: "E_WALLET_TRANSACTIONS_INVALIDBONUSCONTEXT",
	},
};

/** deprecated */
export const DEFAULT_BONUS_CONTEXT_BY_PRODUCT: Record<string, BonusContext> = {
	[ProductType.Casino]: BonusContext.MobileCasino,
	[ProductType.LiveCasino]: BonusContext.MobileLiveCasino,
	[ProductType.Sportsbook]: BonusContext.MobileSportsbook,
	[ProductType.VirtualSports]: BonusContext.MobileVirtualSports,
	[ProductType.Poker]: BonusContext.MgPoker,
	[ProductType.TurkishPoker]: BonusContext.NlcPoker,
	[ProductType.HorseRacing]: BonusContext.HorseRacing,
	[ProductType.Common]: BonusContext.StartPage,
};

export const DEFAULT_BONUS_CONTEXT: Record<string, BonusContext> = {
	[ProductType.Casino]: BonusContext.Casino,
	[ProductType.LiveCasino]: BonusContext.LiveCasino,
	[ProductType.Sportsbook]: BonusContext.Sportsbook,
	[ProductType.VirtualSports]: BonusContext.VirtualSports,
	[ProductType.Poker]: BonusContext.MgPoker,
	[ProductType.TurkishPoker]: BonusContext.NlcPoker,
	[ProductType.HorseRacing]: BonusContext.HorseRacing,
	[ProductType.Common]: BonusContext.StartPage,
};
